<template>
  <base-dialog
    show-close
    :visible.sync="visible"
    class="create-sub-department-dialog"
    width="485px"
  >
    <template v-slot:header>新建下级部门</template>
    <el-form ref="form" :model="form" label-width="110px" :rules="rules" label-position="left">
      <el-form-item label="部门名称" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="上级部门" prop="parentDepartment">
        <user-scope-selector
          tip="选择部门"
          v-model="form.parentDepartment"
          :show-user-tab="false"
          :root-department="rootDepartment"
          :disabled="disabled"
          show-raw-root-department-name
        ></user-scope-selector>
      </el-form-item>
      <el-form-item label="部门负责人" prop="admin">
        <user-scope-selector
          tip="选择部门负责人"
          v-model="form.admin"
          :show-department-tab="false"
          :root-department="rootDepartment"
          :users="curCompanyUsers"
          multiple
        ></user-scope-selector>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import UserScopeSelector from "@/components/UIComponents/UserScopeSelector"
import { saveDepartment } from "@/api/department"

export default {
  name: "create-sub-department-dialog",
  components: { BaseDialog, BaseButton, UserScopeSelector },
  inject: ["curCompanyUsers", "rootDepartment"],
  data() {
    return {
      visible: false,
      rules: {
        name: [{ required: true, message: "请填写部门名称", trigger: "blur" }],
        parentDepartment: [{ required: true, message: "上级部门不能为空", trigger: "blur" }]
      },
      form: {
        name: "",
        parentDepartment: [],
        admin: []
      },
      disabled: true
    }
  },
  methods: {
    open(departmentId) {
      this.form.name = ""
      this.form.parentDepartment = []
      this.form.admin = []
      if (departmentId) {
        this.form.parentDepartment = [{ type: "department", value: departmentId }]
      } else {
        this.disabled = false
      }
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        let parentId = this.form.parentDepartment[0]?.value
        if (!parentId) {
          this.$message.error("上级部门不能为空")
          return
        }
        saveDepartment({
          name: this.form.name,
          parentId: parentId,
          adminIds: this.form.admin.map(item => item.value)
        }).then(() => {
          this.$message.success("创建成功")
          this.$emit("change")
          this.visible = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.create-sub-department-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 18px 60px 8px 24px;
    }
  }
  .el-form ::v-deep {
    .el-form-item {
      margin-bottom: 8px;
      .el-form-item__error {
        position: relative;
      }
    }
    .el-form-item__label,
    .el-form-item__content,
    .el-input,
    .el-cascader {
      line-height: 32px;
    }
    .el-cascader {
      width: 100%;
    }
  }
}
</style>
